import { findIndex } from "lodash"

const templateState = {
  id: -1,
  type: null,
  description: "",
  showPopup: false,
  running: false,
  time: new Date(0, 0, 0)
};

export function TimerReducer(state = { timers: [] }, action) {
  let currentTimer;
  let protocolSection = state.protocolSection;

  if (action.payload === undefined) {
      return state;
  }

  if (action.type !== "CREATE_TIMER" && !action.type.includes("@redux")) {
      if(action.payload.hasOwnProperty("id")){
        if(state.protocolSection.scene.apparatus.hasOwnProperty("timers")){
          currentTimer = state.protocolSection.scene.apparatus.timers[findIndex(state.protocolSection.scene.apparatus.timers, { id: action.payload.id })]
        }
      }
  }

  switch (action.type) {

        case 'CREATE_TIMER':

          //Create new obj from template state
          let newObj = { ...templateState, ...action.payload.props }

          if(protocolSection.scene.apparatus.hasOwnProperty("timers")){
            protocolSection.scene.apparatus.timers = [ ...protocolSection.scene.apparatus.timers, newObj ]
          } else {
            protocolSection.scene.apparatus.timers = [newObj]
          }

          return { ...state, ...{
            protocolSection: protocolSection
          } }

        case "SET_TIMER_RUNNING":
            currentTimer.running = action.payload.running
            protocolSection.scene.apparatus.timers[findIndex(state.timers, { id: action.payload.id })] = currentTimer

            return { ...state, ...{
              protocolSection: protocolSection
            } }
          
        case "SET_TIMER_POPUP":
            currentTimer.showPopup = action.payload.showPopup
            protocolSection.scene.apparatus.timers[findIndex(state.timers, { id: action.payload.id })] = currentTimer

            return { ...state, ...{
              protocolSection: protocolSection
            } }
          
        case "SET_TIMER_TIME":
            currentTimer.time = action.payload.time
            protocolSection.scene.apparatus.timers[findIndex(state.timers, { id: action.payload.id })] = currentTimer

            return { ...state, ...{
              protocolSection: protocolSection
            } }

        case "UNDO":
            //Payload = {lastState}

            if (action.payload.lastState !== null) {

              action.payload.lastState.scene.apparatus.timers

              return { ...state, ...{
                protocolSection: protocolSection
              } }

            } else {
              return state;
            }

        default:
            return state;
    }
}
